
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compress-jpeg",
      function () {
        return require("private-next-pages/compress-jpeg/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compress-jpeg"])
      });
    }
  